import React from 'react';
import { useParams } from 'react-router-dom';
import BaseLayout from '@/components/layouts/BaseLayout';
import ArticleCard from '@/components/Article/ArticleCard';
import { useArticles } from '@/hooks/useArticles';

const CategoryPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const params = React.useMemo(() => ({ category: slug }), [slug]);
  const { articles, isLoading, error } = useArticles(params);

  if (isLoading) {
    return (
      <BaseLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="animate-pulse space-y-8">
            <div className="h-8 bg-gray-200 rounded w-1/4 mb-8"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="h-80 bg-gray-200 rounded-xl"></div>
              ))}
            </div>
          </div>
        </div>
      </BaseLayout>
    );
  }

  if (error) {
    return (
      <BaseLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Error Loading Articles</h1>
            <p className="text-gray-600">{error}</p>
          </div>
        </div>
      </BaseLayout>
    );
  }

  const filteredArticles = articles.filter(article =>
    (article.categories ?? []).some(cat => cat.slug === slug)
  );

  const categoryName = filteredArticles[0]?.categories.find(c => c.slug === slug)?.name || slug;

  return (
    <BaseLayout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 capitalize">
          {categoryName}
        </h1>
        
        {filteredArticles.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-600">No articles found in this category.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        )}
      </div>
    </BaseLayout>
  );
};

export default CategoryPage; 